import { createContext, useContext } from 'react';

/**
 * The key currently spotlighted on the canvas, with the ids to leave lit.
 *
 * `null | { keyId, nodeIds: Set<string>, edgeIds: Set<string> }`
 *
 * Provided by Canvas.js and read by SituationNode, Edge and the edge labels. It
 * is its own context rather than a field threaded through props so that the
 * ReactFlow `nodeTypes` wrapper and the memoised label groups never have to
 * change identity for it: while nothing is highlighted the value stays `null`
 * and nothing re-renders.
 */
export const KeyHighlightContext = createContext(null);

export const useKeyHighlight = () => useContext(KeyHighlightContext);

export default KeyHighlightContext;
